<template>
	<section class="app-presets">
		<h2 class="app-presets__title">
			{{ $t('presets') }} <span class="flag flag--base-font-color">{{ presets.length }}</span>
		</h2>
		<template v-if="items.length">
			<ul class="app-presets__list">
				<li class="app-presets__item" v-for="(preset, index) in items" :key="'preset-' + preset.id + '-' + index">
					<article
						:class="[
							'app-presets-card',
							`app-presets-card--bg-${this.generateRandomNamber(9)}`,
							`app-presets-card--icon-${this.generateRandomNamber(22)}`,
							{
								'app-presets-card--brend': preset.is_private,
							}
						]"
					>
						<a :href="preset.url" class="app-presets-card__link">
							<h3 class="app-presets-card__title">{{ preset.name }}</h3>
							<div class="app-presets-card__bottom">
								<ul class="app-presets-card__list">
									<li class="app-presets-card__item">
										<div class="course-tag course-tag--bg-white">{{ $t('courses', preset.courses_count) }}</div>
									</li>
									<li v-if="preset.is_private" class="app-presets-card__item">
										<div class="course-tag course-tag--outline-white">{{ current_company_name }}</div>
									</li>
								</ul>
							</div>
						</a>
					</article>
				</li>
			</ul>

			<div class="app-presets__bottom">
				<Paginate
					:page-count="pagesCount"
					:click-handler="changePage"
					:container-class="'app-catalog-pagination'"
				>
				</Paginate>
			</div>
		</template>
	</section>
</template>

<script>
import Paginate from "vuejs-paginate-next";

export default {
	name: "PresetSelection",

	components: {
		Paginate
	},

	props: {
		presets: Array,
		current_company_name: {
			type: String,
			default: ''
		}
	},

	data() {
		return {
			loading: true,
			currentPage: 1,
			paginationOffset: 0,
			itemsTotal: this.presets ? this.presets.length : null,
			itemsPerPage: 6,
			items: this.presets.slice(0, 6)
		};
	},

	mounted() {
	},

	computed: {
		pagesCount() {
			return Math.ceil(this.itemsTotal / this.itemsPerPage);
		}
	},

	methods: {
		generateRandomNamber(limit) {
			return Math.floor(Math.random() * limit) + 1;
		},

		changePage(pageNum) {
			this.paginationOffset = (this.itemsPerPage * pageNum) - this.itemsPerPage;
			this.items = this.presets.slice(this.paginationOffset, this.paginationOffset + this.itemsPerPage);
		},
	}
};
</script>
